import PropTypes from "prop-types";
import { FormattedDate, FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import "./TechnicalErrorDuplicateBooking.scss";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const TechnicalErrorDuplicateBooking = ({
	startDate,
	endDate,
	bookingReference,
	email,
	isWhiteLabel,
	shop,
}) => {
	return (
		<div className="technical-error">
			<div className="technical-error__intro">
				<FormattedMessage
					id="technical.error.duplicate.booking.label"
					values={{
						startDate: (
							<FormattedDate
								timeZone="UTC"
								value={new Date(startDate)}
								day="2-digit"
								month="2-digit"
								year="numeric"
							>
								{monthLabel => (
									<span className="technical-error__date">{monthLabel}</span>
								)}
							</FormattedDate>
						),
						endDate: (
							<FormattedDate
								timeZone="UTC"
								value={new Date(endDate)}
								day="2-digit"
								month="2-digit"
								year="numeric"
							>
								{monthLabel => (
									<span className="technical-error__date">{monthLabel}</span>
								)}
							</FormattedDate>
						),
						bookingReference: (
							<span className="technical-error__reference-number">
								{bookingReference}
							</span>
						),
						email: <span className="technical-error__email">{email}</span>,
					}}
				/>
			</div>

			<DontLeave message={<FormattedMessage id="confirmation.contact.continue.headline" />}>
				{isWhiteLabel ? (
					<Button
						to={{ pathname: "/account/mybookings" }}
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						label={
							<FormattedMessage id="technical.error.duplicate.booking.cta.label" />
						}
						data-testid={"go-to-my-bookings-button"}
					/>
				) : (
					<Button
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						label={
							<FormattedMessage id="technical.error.duplicate.booking.cta.label" />
						}
						to={{ pathname: `https://www.perfectstay.com/${shop}` }}
						target="_blank"
						rel="noopener noreferrer"
						data-testid={"go-to-my-bookings-button"}
					/>
				)}
			</DontLeave>
		</div>
	);
};

TechnicalErrorDuplicateBooking.propTypes = {
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	bookingReference: PropTypes.string,
	email: PropTypes.string,
	shop: PropTypes.string,
	isWhiteLabel: PropTypes.bool,
};

export default TechnicalErrorDuplicateBooking;
